import React from 'react';

/* eslint-disable-next-line no-restricted-imports */
import { Link as GatsbyLink } from 'gatsby';
import styled from '@emotion/styled';

const StyledGatsbyLinkBase = styled(GatsbyLink)({
  label: 'gatsby-link-styled'
});

const StyledGatsbyLink = (props: any) => (
  /* eslint-disable-next-line react/jsx-sort-props */
  <StyledGatsbyLinkBase css={props.css} className={props.className} {...props}>
    {props.children}
  </StyledGatsbyLinkBase>
);

export default StyledGatsbyLink;
